// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"088af2ee","70":"bc3f6ae9","248":"c386406d","273":"dd516f6a","911":"778d001f","930":"f5f3c80d"}[chunkId] + ".chunk.css";
};